import * as JSX from './toJSX';
import * as JS from './toJS';

export let ing          = false;
export let handle = JSX.Generator;

export const onJSX = ()       => {
	handle = JSX.Generator;
	ing = true;
};

export const onJS$ = (compilerOptions                    )       => {
	JS.on$(compilerOptions);
	handle = JS.Generator;
	ing = true;
};
export const onJS = (jsx                  )       => {
	JS.on(jsx);
	handle = JS.Generator;
	ing = true;
};

export const off = ()       => {
	JS.off();
	ing = false;
};
